import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";

export const About = () => {
  const { t } = useTranslation();
  const facts = t("about.facts", { returnObjects: true });

  return (
    <section id="chi-siamo" className="relative bg-[#0D0F12] px-6 py-28 lg:px-12 lg:py-40" data-testid="about-section">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]" data-testid="about-overline">
              {t("about.overline")}
            </p>
            <h2 className="mt-4 font-display text-4xl font-light leading-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl" data-testid="about-heading">
              {t("about.h2pre")} <em className="italic text-[#D6705A]">{t("about.h2em")}</em>{t("about.h2post")}
            </h2>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="font-display text-2xl font-light leading-snug text-[#C9C7C3] md:text-3xl" data-testid="about-lead">
                {t("about.p1")}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-xl text-sm leading-relaxed text-[#A0A0A0] md:text-base" data-testid="about-body">
                {t("about.p2")}
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <ul className="mt-10 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" data-testid="about-facts">
                {facts.map((f, i) => (
                  <li key={f} className="bg-[#0D0F12] px-5 py-4">
                    <span className="mr-3 font-code text-[10px] text-[#D6705A]">0{i + 1}</span>
                    <span className="text-sm text-[#C9C7C3]">{f}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.4}>
              <button
                onClick={() => scrollTo("#prenota")}
                className="mt-10 flex items-center gap-2 font-code text-[11px] uppercase tracking-[0.25em] text-[#D6705A] transition-colors duration-300 hover:text-[#F9F8F6]"
                data-testid="about-cta"
              >
                {t("about.cta")} <ArrowUpRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
